/**
 * Parses any arabic digits
 * @param  {any} digit - The digit typed by the user
 * @returns {any} - parsed digit
 */
export const parseArabic = (digit: string): string => {
    const formattedDigit = digit
        .replace(/[٠١٢٣٤٥٦٧٨٩]/g, (d: string) => `${d.charCodeAt(0) - 1632}`)
        .replace(/[۰۱۲۳۴۵۶۷۸۹]/g, (d: string) => `${d.charCodeAt(0) - 1776}`)
        .replace(/ /g, '');

    return formattedDigit;
};

/**
 * Removes special characters from text
 * @param  {string} text - Text to be sanitized
 * @returns {string} - Sanitized text
 */
export const sanitizeText = (text: string): string => {
    return text
        .replace(/</g, '')
        .replace(/>/g, '')
        .replace(/%/g, '')
        .replace(/=/g, '')
        .replace(/"/g, '')
        .replace(/'/g, '');
};

export const truncateWithEllipsis = (text = '', limit = 50, threshold = 5): string =>
    text.length > limit + threshold ? `${text.substr(0, limit).trim()}...` : text;
